import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { QueryRouteBarrelTypes } from '@web/utils/ApiClient';

export const useInvalidateCache = (): {
  invalidateCache: (routeBarrelKeys: Array<keyof QueryRouteBarrelTypes>) => void;
} => {
  const queryClient = useQueryClient();

  const invalidateCache = useCallback(
    (routeBarrelKeys: Array<keyof QueryRouteBarrelTypes>): void => {
      routeBarrelKeys.forEach((key) => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey[1] === key,
        });
      });
    },
    [queryClient],
  );

  return { invalidateCache };
};
